import { useLayoutEffect } from "react";
import { useHistory } from "react-router-dom";

const isPageReload = (): boolean => {
  const [navigationEntry] = performance.getEntriesByType(
    "navigation"
  ) as PerformanceNavigationTiming[];
  if (navigationEntry) {
    return navigationEntry.type === "reload";
  }
  // Older browsers without the Navigation Timing Level 2 API.
  return (performance as any).navigation?.type === 1;
};

/**
 * The wizard's steps thread all their state through `history`'s
 * `location.state` on the assumption that refreshing the page clears it and
 * restarts the wizard from step 0 (see `deviceRegistrationLocationState.ts`).
 * That assumption is false: react-router v5 (`history` v4) initializes from
 * `window.history.state`, which the browser preserves across a same-entry
 * reload — only a fresh top-level navigation clears it. Mounted once at the
 * router root (persists across in-app navigation, only remounts on a real
 * page load), so this runs exactly once per reload, before any step's own
 * mount guard reads `location.state`.
 */
const ClearStaleStateOnReload: React.FC = () => {
  const history = useHistory();

  useLayoutEffect(() => {
    if (
      isPageReload() &&
      history.location.pathname.startsWith("/register-device") &&
      history.location.state !== undefined
    ) {
      history.replace(history.location.pathname, undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default ClearStaleStateOnReload;
